<app-info-popup
  #infoModal
  [title]="'Meeting Not Logged'"
  [message]="
    'This meeting wasn’t logged in convverse.ai. It may have happened offline or the bot wasn’t granted access'
  "
  [confirmText]="'Got it'"
></app-info-popup>

<app-main-wrapper title="My Past Meetings">
  <app-email-modal
    #emailModal
    [meetingBotId]="meetingBotId"
    [emails]="selectedEmails"
  ></app-email-modal>
  <div>
    <div
      class="d-flex gap-2 mb-2 mr-3"
      style="align-items: end; justify-content: space-between"
    >
      <p
        class="timezone-note"
        style="
          font-size: 0.75rem;
          color: #666;
          margin-top: -5px;
          margin-bottom: 10px;
        "
      >
        * All times displayed per your calendar time zone
      </p>
      <button (click)="toggleExpandCollapse()" class="icon-button">
        <fa-icon *ngIf="!allExpanded" [icon]="faSquarePlus" size="2x"></fa-icon>
        <fa-icon *ngIf="allExpanded" [icon]="faMinusSquare" size="2x"></fa-icon>
      </button>
    </div>

    <div class="search-filter-row">
      <div class="search-box">
        <i class="fas fa-search"></i>
        <input
          type="text"
          class="search-input"
          placeholder="Search for keywords, participants, and more..."
        />
      </div>

      <!-- ── Date range filter (inline) ────────────────────────────── -->
      <div class="date-filter-inline">
        <div class="date-input-group">
          <input type="date" class="date-input-compact" [(ngModel)]="draftFrom" [max]="draftTo || ''" />
          <span class="date-separator">→</span>
          <input type="date" class="date-input-compact" [(ngModel)]="draftTo" [min]="draftFrom || ''" />
        </div>
        <button class="filter-apply-btn-compact" (click)="applyDateFilter()" [disabled]="!draftFrom && !draftTo" title="Apply date filter">
          Apply
        </button>
        <button class="filter-clear-btn-compact" *ngIf="isFilterActive" (click)="clearDateFilter()" title="Clear date filter">
          Clear
        </button>
      </div>
    </div>

    <div
      class="d-flex justify-content-between align-items-center flex-wrap mb-3 gap-2"
    >
      <!-- <div class="flex-grow-1" style="max-width: 280px">
        <input
          type="text"
          id="simpleCalendarTimeUpRight"
          class="form-control"
          style="
            box-shadow: none;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          "
          readonly
          ngxDaterangepickerBootstrap
          [(ngModel)]="selectedSimpleCalendarTimeUpRight"
          [drops]="dropsDown"
          [opens]="opensRight"
          [locale]="localeTime"
          [timePicker]="true"
          [timePickerSeconds]="true"
          [timePicker24Hour]="true"
          [showCancel]="true"
          [linkedCalendars]="true"
          [alwaysShowCalendars]="false"
          [showRangeLabelOnInput]="false"
          [keepCalendarOpeningWithRange]="false"
          [isTooltipDate]="isTooltipDate"
          [isCustomDate]="isCustomDate"
          [isInvalidDate]="isInvalidDate"
          [minDate]="minDate"
          (datesUpdated)="datesUpdatedRange($event)"
          aria-describedby="simpleCalendarTimeUpRightDesc"
        />
      </div> -->
    </div>
  </div>

  <div class="date-section" *ngFor="let item of allMeetings; let i = index">
    <div
      class="date-header d-flex justify-content-between align-items-center"
      style="cursor: pointer"
    >
      <div
        class="d-flex align-items-center gap-2"
        (click)="$event.stopPropagation()"
      >
        <span>{{ item.date | date : "EEEE, MMM dd" }}</span>
      </div>
      <div>
        <button
          class="sort-button btn btn-link p-0"
          (click)="toggleMeetingSort(item.date); $event.stopPropagation()"
          aria-label="Toggle meeting sort order"
          title="Toggle meeting sort order"
          style="
            font-size: 1.2rem;
            line-height: 1;
            color: inherit;
            min-width: 20px;
          "
        >
          <fa-icon
            [icon]="meetingSortOrder[item.date] ? faAngleDown : faAngleUp"
          ></fa-icon>
        </button>
        <button
          class="collapse-button btn btn-link p-0"
          (click)="toggleCollapse(item.date)"
          aria-label="Toggle collapse"
          title="Toggle collapse"
          style="
            font-size: 1.5rem;
            line-height: 1;
            color: inherit;
            text-align: right;
            min-width: 30px;
          "
        >
          <fa-icon
            *ngIf="isCollapsed(item.date)"
            [icon]="faSquarePlus"
          ></fa-icon>
          <fa-icon
            *ngIf="!isCollapsed(item.date)"
            [icon]="faMinusSquare"
          ></fa-icon>
        </button>
      </div>
    </div>

    <div class="meetings-list" *ngIf="!isCollapsed(item.date)">
      <ng-container *ngFor="let meeting of item.meetings">
        <div
          class="meeting-row"
          (click)="goToOpportunity(meeting)"
          [style.cursor]="meeting.opportunity_id ? 'pointer' : 'default'"
          [class.disabled]="!meeting.opportunity_id"
        >
          <div class="meeting-time">
            {{ meeting.start_time | date : "HH:mm" }} -
            {{ meeting.end_time | date : "HH:mm" }} <br />
            <span
              class="duration"
              *ngIf="meeting.actual_duration_minutes"
              style="color: #000; display: block; text-align: center"
            >
              {{ formatDuration(meeting.actual_duration_minutes) }} ′
            </span>
          </div>
          <div class="meeting-details">
            <div class="meeting-client">
              {{ meeting.opportunity_name }} - {{ meeting.meeting_title }}
            </div>
            <div class="meeting-title">
              <span class="speakers" *ngIf="meeting.distinct_speakers?.length">
                <i class="fa-solid fa-users"></i>
                {{ meeting.distinct_speakers.join(", ") }}
              </span>
            </div>
          </div>
          <div
            class="meeting-actions"
            (click)="emailMeetingPopup(meeting, $event)"
          >
            <i
              class="fas fa-envelope action-icon"
              title="Email meeting summary"
            ></i>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Pagination -->
  <div class="pagination-bar" *ngIf="!isLoading && (currentPage > 1 || hasNextPage)">
    <button class="page-btn" (click)="goToPrevPage()" [disabled]="currentPage === 1">
      &lsaquo; Prev
    </button>
    <span class="page-indicator">Page {{ currentPage }}</span>
    <button class="page-btn" (click)="goToNextPage()" [disabled]="!hasNextPage">
      Next &rsaquo;
    </button>
  </div>

  <div class="pagination-loading" *ngIf="isLoading">
    Loading...
  </div>
</app-main-wrapper>
